import Progress from 'easy-circular-progress';
import { Inject } from 'vue-di-container';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import LoaderService from '../../../Services/LoaderService';
import { Toaster } from '../../../Services/toast';
import { SenderType } from '../../../shared/Enums/SenderType';
import UserRoleService from '../../../shared/userService/UserRoleService';
import UserService from '../../../shared/userService/UserService';
import SenderComplaintsService from '../SenderComplaintsService';
import WithRender from './ComplaintDetails.html';
import { ComplaintDetailsModel } from './ComplaintDetailsModel';
import FileSaver from 'file-saver';
import { ComplaintAttachmentModel } from './ComplaintAttachmentModel';
import { EditComplaintDetailsModel } from './EditComplaintDetailsModel';


@WithRender
@Component({
    components: {
        Progress,
    },
    diProvide: [
        UserService,
        UserRoleService,
        SenderComplaintsService,
    ],
})
export default class ComplaintDetails extends Vue {
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Inject(LoaderService) public loaderService!: LoaderService;
    @Inject(SenderComplaintsService) public senderComplaintsService!: SenderComplaintsService;
    @Prop({ type: Boolean, default: false })
    @Prop({ type: String, default: '' })
    public layoutSup: boolean | any;

    public complaint: ComplaintDetailsModel = {
        complaintId: '',
        senderType: 0,
        clientName: '',
        referenceNumber: '',
        providerName: '',
        customerType: 0,
        representativeEmail: '',
        representativePhone: '',
        representativeName: '',
        senderName: '',
        isCritical: false,
        senderExpiryDate: '',
        deactivatedBy: '',
        reactivatedBy: '',
        gracePeriod: 0,
        senderStatus: 0,
        complaintStatus: 0,
        attachmentList: [],
        comments: '',
    };
    public reactivateids: string[] = [];
    public editComplaintModel: EditComplaintDetailsModel = {
        comments: '',
        attachmentList: [],
        tcn: ''
    };
    public reactivateDialog: boolean = false;
    public closeComplaintDialog: boolean = false;
    public deactivateComplaintDialog: boolean = false;
    public editComplaintDialog: boolean = false;
    public typeFile: string = '';
    public headers: any = [
        { text: this.$t('shared.attachmentName'), value: 'fileName', align: 'center', sortable: false },
        { text: this.$t('shared.addedDate'), value: 'createdDate', align: 'center', sortable: false },
        { text: this.$t('shared.actions'), sortable: false, value: 'id', align: 'center', width: '100' },
    ];
    public attachmentName: string = '';
    public userRole: number = 0;
    public User: any;
    public customerType: string = '';
    public id: string | any;
    public isEditMode: boolean = false;
    public editText: string = this.$t('shared.enableToEdit').toString();
    public senderType: SenderType[] = [];
    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        this.User = await this.userService.getUser();
        this.userRole = this.userRoleService.GetUserRole(this.User);
        if (this.userRole == 16) {
            this.getHeaders();
        }
        this.id = this.$route.params.id;
        const response = await this.senderComplaintsService.GetDetails(this.id);
        if (response.isSuccess === false) {
            Toaster.error(response.errorMessage);
        }
        else {
            this.complaint = response.result;
            this.getSenderType();
        }
    }
    public getHeaders() {
        const fruadUserColumn =
            { text: this.$t('shared.addedBy'), value: 'createdBy', align: 'center', sortable: false };
        this.headers.splice(2, 0, fruadUserColumn);
    }
    public convertEdit() {
        this.isEditMode = !this.isEditMode;
        if (this.isEditMode) {
            this.editText = this.$t('shared.disableToEdit').toString();
        } else {
            this.editText = this.$t('shared.enableToEdit').toString();
        }
    }
    public onPickFile() {
        (this.$refs.contractAttachment as any).click();
    }
    public showEditComplaintDialog(id: string) {
        this.editComplaintDialog = true;
    }
    public hideEditComplaintDialog() {
        this.editComplaintDialog = false;
    }
    public getRate() {
        return (this.complaint.gracePeriod / 30) * 100;
    }
    public async save() {
        this.editComplaintModel.tcn = this.id;
        this.editComplaintModel.comments = this.complaint.comments;
        const response = await this.senderComplaintsService.EditComplaint(this.editComplaintModel);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        } else {
            Toaster.success(this.$t('senderComplaints.complaintEditedSuccessfully').toString());
        }
        this.editComplaintDialog = false;
        await this.reload();
    }
    public get canAddAttachment(): boolean {
        return this.complaint.attachmentList.length < 3
    }

    public get hasMenuOptions() {
        return (
            (this.complaint.complaintStatus === 2 && this.complaint.senderStatus === 4
                && this.userRole === 16) ||
            (this.complaint.complaintStatus === 1 && this.userRole === 16 &&
                (this.complaint.senderStatus === 7 || this.complaint.senderStatus === 5))
        );
    }

    public onFilePicked(event: any) {
        const files: any[] = event.target.files;
        const modelArray: ComplaintAttachmentModel = {} as ComplaintAttachmentModel;
        const editArray: ComplaintAttachmentModel = {} as ComplaintAttachmentModel;
        Array.prototype.forEach.call(files, (file, index) => {
            modelArray.fileName = file.name;
            if (file.size > 3000000) {
                Toaster.error(this.$t('shared.fileSizeExceedsTheLimit').toString());
            }
            else {
                this.attachmentName = file.name;
                const reader = new FileReader();
                reader.onloadend = (fileData: any) => {
                    modelArray.fileContent = fileData.target.result.split(',')[1];
                    modelArray.createdBy = this.User.username;
                    modelArray.createdDate = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");
                    this.complaint.attachmentList.push(modelArray);
                    editArray.createdDate = new Date().toISOString();
                    editArray.fileName = file.name;
                    editArray.fileContent = fileData.target.result.split(',')[1];
                    this.editComplaintModel.attachmentList.push(editArray);
                };
                reader.readAsDataURL(file);
            }
        });
    }
    public checkColor(typeStatus: string) {
        typeStatus = typeStatus.toString();
        switch (typeStatus) {
            case '1': {
                return '#c427ba';
            }
            case '2': {
                return '#5aaa0b';
            }
            case '3': {
                return '#C42727';
            }
            case '4': {
                return '#aaa7a7';
            }
            case '5': {
                return '#014bb1';
            }
            case '7': {
                return '#5c9bf2';
            }
            default: {
                return '#F78500';
            }
        }
    }
   
    public GetSenderStatus(typeStatus: number) {
        switch (typeStatus) {
            case 1: {
                return 'Pending Approval';
            }
            case 2: {
                return 'Approved';
            }
            case 3: {
                return 'Rejected';
            }
            case 4: {
                return 'Deactivated';
            }
            case 5: {
                return 'Expired';
            }
            case 6: {
                return 'Deleted';
            }
            case 7: {
                return 'Paid';
            }
            case 9: {
                return 'Pending For Verify';
            }
            case 10: {
                return 'Pending For Review';
            }
        }
    }
    public getCustomerTypeText(typeId: number) {
        switch (typeId) {
            case 1:
                return this.$t('shared.government').toString();
            case 2:
                return this.$t('shared.charity').toString();
            case 3:
                return this.$t('shared.private').toString();
            case 4:
                return this.$t('shared.international').toString();
            default:
                return '-';
        }
    }

    public getSenderType() {
        const senderBinary = this.complaint.senderType;
        if ((senderBinary & 1) === 1) {
            this.senderType.push(1);
        }
        if ((senderBinary & 2) === 2) {
            this.senderType.push(2);
        }
        if ((senderBinary & 4) === 4) {
            this.senderType.push(4);
        }
        if ((senderBinary & 8) === 8) {
            this.senderType.push(8);
        }
    }
    public showReactivateDialog(id: string) {
        if (id !== '') {
            this.reactivateids.push(id);
        }
        this.reactivateDialog = true;
    }
    public showCloseComplaintDialog() {
        this.closeComplaintDialog = true;
    }
    public hideReactivateDialog() {
        this.reactivateDialog = false;
    }
    public showDeactivateComplaintDialog() {
        this.deactivateComplaintDialog = true;
    }
    public hideDeactivateComplaintDialog() {
        this.deactivateComplaintDialog = false;
    }
    public hideCloseComplaintDialog() {
        this.closeComplaintDialog = false;
    }
    public async Reactivate() {
        let ids: string[] = [];
        ids.push(this.id);
        const response = await this.senderComplaintsService.Reactivate(ids);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            this.reactivateDialog = false;
            await this.reload();
        } else {
            this.reactivateDialog = false;
            Toaster.success(this.$t('senderComplaints.reactivatedsuccessfully').toString());
            await this.reload();
        }
    }

    public async closeComplaint() {
        const response = await this.senderComplaintsService.closeComplaint(this.id);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        } else {
            Toaster.success(this.$t('senderComplaints.complaintClosedSuccessfully').toString());
        }
        await this.reload();
        this.closeComplaintDialog = false;
    }
    public async deactivateComplaint() {
        const response = await this.senderComplaintsService.deactivateComplaint(this.id);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        } else {
            Toaster.success(this.$t('senderComplaints.complaintDeactivatedsuccessfully').toString());
        }
        await this.reload();
        this.deactivateComplaintDialog = false;
    }
    public async reload() {
        this.id = this.$route.params.id;
        const response = await this.senderComplaintsService.GetDetails(this.id);
        if (response.isSuccess === false) {
            Toaster.error(response.errorMessage);
        }
        else {
            this.complaint = response.result;
            this.getSenderType();
        }
        this.editComplaintModel = {
            comments: '',
            attachmentList: [],
            tcn: ''
        };
        this.isEditMode = false;
    }
    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement:
                return this.$t('shared.advertisement').toString();
            case SenderType.Service:
                return this.$t('shared.service').toString();
            case SenderType.Awareness:
                return this.$t('shared.awareness').toString();
            case SenderType.Warning:
                return this.$t('shared.warning').toString();
            default:
                return '-';
        }
    }
    public async downloadFile(file: ComplaintAttachmentModel) {
        const fileContent = await this.senderComplaintsService.GetFileContent(file.id);
        const array = Buffer.from(fileContent, 'base64');
        const blob = new Blob([array], { type: 'application/pdf' });
        FileSaver.saveAs(blob, file.fileName);
    }
}